import React from 'react';
import ReactDOM from 'react-dom';
import styles from './index.less';
import cx from 'classnames';
import BaseToast, { TypeEnum } from './base-toast';

// CommonMessage.open('这是一个测试', 3000, false);

export default class CommonMessage {
  static open(content, duration, mask) {
    const container = document.createElement('div');
    document.body.appendChild(container);

    ReactDOM.render(
      <div className={cx(styles.root, styles.fadeIn)}>
        {mask && <div className={styles.mask} />}
        <div className={styles.messageContent}>{content}</div>
      </div>,
      container
    );

    setTimeout(() => {
      const rootElement = container.querySelector(`.${styles.root}`);
      rootElement.classList.remove(styles.fadeIn);
      rootElement.classList.add(styles.fadeOut);

      setTimeout(() => {
        ReactDOM.unmountComponentAtNode(container);
        container.remove();
      }, 1000);
    }, duration);
  }

  static success(text, duration = 1500, mask = true) {
    this.open(<BaseToast text={text} />, duration, mask);
  }
  static fail(text, duration = 1500, mask = true) {
    this.open(<BaseToast type={TypeEnum.FAIL} text={text} />, duration, mask);
  }
  static error(text, duration = 1500, mask = true) {
    this.open(<BaseToast type={TypeEnum.FAIL} text={text} />, duration, mask);
  }
  static info(text, duration = 1500, mask = true) {
    this.open(<BaseToast type={TypeEnum.INFO} text={text} />, duration, mask);
  }
}
